import { Component, Prop, Watch, Vue, Ref } from 'vue-property-decorator';

import { PaymentMethod } from '@/core/payment-methods/constants';

@Component({
    data() {
        return {
            selectedMethod: null,
            lastScroll: 0
        };
    }
})
export default class PaymentMethodSlideGroup extends Vue {
    @Ref() slideGroup;

    @Prop(Array)
    methods: Array<PaymentMethod>;

    @Prop(Object)
    value: PaymentMethod;

    @Prop({ type: Number, default: 110 })
    itemWidth: number;

    selectedMethod: PaymentMethod;

    lastScroll: number;

    mounted() {
        this.selectedMethod = this.value;
    }

    prevClick() {
        this.$nextTick(() => {
            if (this.slideGroup.scrollOffset < this.lastScroll) {
                this.slideGroup.scrollOffset = this.lastScroll - 2 * this.itemWidth;
            }

            this.lastScroll = this.slideGroup.scrollOffset;
        });
    }

    nextClick() {
        this.$nextTick(() => {
            if (this.slideGroup.scrollOffset > this.lastScroll) {
                this.slideGroup.scrollOffset = this.lastScroll + 2 * this.itemWidth;
            }

            this.lastScroll = this.slideGroup.scrollOffset;
        });
    }

    @Watch('value')
    onChangeValue(value) {
        this.selectedMethod = value;
    }

    @Watch('selectedMethod')
    onChangeSelectedMethod(value) {
        this.$emit('input', value);
    }

    selectMethod(method: PaymentMethod) {
        this.selectedMethod = method;
    }
}
